import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Box, Page } from "signoxe/components/layout";
import {setPageTitle, getEmailLogReport, downloadCampaignReport, downloadDeviceReport} from "signoxe/actions"

class ReportDownladLinkPage extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    setPageTitle: PropTypes.func.isRequired,

  };

  constructor(props) {
    super(props);

    this.state = {
      addMode: false,
      currentKey: null,
      reportLog:null
    };
  }

  
  async componentDidMount() {
   
    this.props.setPageTitle("Download Reports");
    try {
      localStorage.removeItem("device_report_slug")
      const report = await getEmailLogReport(this.props.match.params.slug);
      this.setState({ reportLog: report });
    } catch (err) {
      console.error('Error fetching event locations:', err);
      alert(err);
    }
    

  }


  render() {
    const {reportLog} = this.state

    console.log("slug report", reportLog)
      
    return (
      <Page className="asset-content-popup">
        <Box
          className="modal-wrapper"
          direction="column"
          justifyContent="center"
        >
          {reportLog && reportLog.id ?
          <div className="">
          {reportLog.category == "auto_reports" ? <h5 className="hostpage text-center mt-14 mb-2"> Click on the link below to download your Auomated Reports</h5>:  <h5 className="hostpage text-center mt-14 mb-2"> Click on the link below to download your Requested Reports</h5>}
          <div className="hostpage">
            {reportLog.device_report && <div className="hostLink">
            <a href="#" className="" onClick={() => downloadDeviceReport(reportLog.slug)}>
                <i
                  className="fas fa-download"
                  style={{ marginRight: "0.5rem" }}
                ></i>
                Device Report
              </a>
            </div>}
           { reportLog.campaign_report && <div className="hostLink">
           <a href="#" className="" onClick={() => downloadCampaignReport(reportLog.slug)}>
                <i
                  className="fas fa-download"
                  style={{ marginRight: "0.5rem" }}
                ></i>
                Campaign Report
              </a>
            </div>}
          </div>

          </div>:
          <div>{reportLog && !reportLog.id && <h5 className="hostpage text-center mt-14 mb-2"> Report not Found</h5>}
          </div>}
          
        </Box>
      </Page>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    setPageTitle,
    getEmailLogReport
  };
};

export default connect(mapStateToProps, {})(ReportDownladLinkPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ReportDownladLinkPage/index.js